import { useMediaQuery } from '@mantine/hooks'

export function useMobileSwitch() {
  const is_mobile = useMediaQuery(`(max-width: 36em)`)

  return function mobile_switch<T>({ base, sm }: { base: T; sm: T }): T {
    return is_mobile ? base : sm
  }
}
